import { CONV_STORAGE, kinoControls, kinoParticipants, permissions, room, socket, spacesView, Video, volumeManager } from "../libs/roomnew";


export default class LockMasterVolume{
    constructor(){
        this.masterVolumeContainer  = $('#masterAudioContainer');
        this.lockMasterVolumeDiv    = $('#lockMasterVolumeContainer');
        this.masterVolumeButton     = $('#audioMasterVolume');
        this.masterVolumeDisabled   = false;
        this.masterVolumeUnlockContainer = null;
        this.chatterLockIcon=`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 10.0001V14.0001C3 14.5501 3.45 15.0001 4 15.0001H7L10.29 18.2901C10.92 18.9201 12 18.4701 12 17.5801V6.41008C12 5.52008 10.92 5.07008 10.29 5.70008L7 9.00008H4C3.45 9.00008 3 9.45008 3 10.0001ZM16.5 12.0001C16.5 10.2301 15.48 8.71008 14 7.97008V16.0201C15.48 15.2901 16.5 13.7701 16.5 12.0001ZM14 4.45008V4.65009C14 5.03009 14.25 5.36009 14.6 5.50009C17.18 6.53009 19 9.06008 19 12.0001C19 14.9401 17.18 17.4701 14.6 18.5001C14.24 18.6401 14 18.9701 14 19.3501V19.5501C14 20.1801 14.63 20.6201 15.21 20.4001C18.6 19.1101 21 15.8401 21 12.0001C21 8.16008 18.6 4.89008 15.21 3.60009C14.63 3.37009 14 3.82008 14 4.45008Z" fill="#032836"/></svg>`;


        //Icons
        this.unlockIcon             = `<i class="fas fa-solid fa-unlock"></i>`;
        this.lockIcon               = `<i class="fas fa-solid fa-lock"></i>`;

        this.events();
    }

    events(){
        let lm = this;
        socket.events.disableMasterVolume = function(request){
            console.error(request);
            if(!request.data.unlockMasterVolume){
                lm.disableMasterVolumeHandler(request.data)
            }
        }

        socket.events.enableMasterVolume = function(request){
            console.error(request);
            if(request.data.unlockMasterVolume){
                lm.enableMasterVolumeHandler(request.data);
            }
        }

        lm.masterVolumeContainer.on('mouseenter', function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        })
    }

    addOptionButton(){
        try {
            const hasAccess=permissions.hasChatterLock()

            if(!hasAccess){
                return;
            }

            kinoControls.registerControl('lock-chatter',this.chatterLockIcon,'Chatter Lock',"switch",this.masterVolumeDisabled,(el)=>{
                if(this.masterVolumeDisabled){
                    this.enableMasterVolume();
                }else{
                    this.disableMasterVolume();
                }
            });
        }catch {

        }
    }

    isLocked(){
        if(permissions.isWorkspace){
            return this.masterVolumeDisabled && permissions.shouldLockChatter();
        }else{
            return this.masterVolumeDisabled;
        }
    }

    renderUnlockMasterVolumeBtn(skipCheck=false){
        let lm = this;
        if(lm.masterVolumeUnlockContainer || !permissions.hasChatterLock()){
            return
        }
        console.log('Rendering the master volume unlock button');

        lm.masterVolumeUnlockBtn = $('<button/>',{
            class: `btn btn-transparent ${lm.masterVolumeDisabled ? 'success' : ''}`,
            html: lm.masterVolumeDisabled ? lm.lockIcon : lm.unlockIcon
        }).on('click', function(){
            if(lm.masterVolumeDisabled){
                lm.enableMasterVolume();
            }else{
                lm.disableMasterVolume();
            }
        });
        lm.masterVolumeUnlockContainer = $('<div/>',{
            class: 'unlockMasterVolumeContainer',
            html: [lm.masterVolumeUnlockBtn]
        });

        lm.lockMasterVolumeDiv.append(lm.masterVolumeUnlockContainer)
        lm.masterVolumeButton.addClass('masterVolumeLockAdded');
    }

    renderUnlockMasterVolumeToNewMod(){
        let lm = this;
        if(lm.masterVolumeDisabled){
            // lm.renderUnlockMasterVolumeBtn();
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',true);
        }
        lm.addOptionButton();
    }

    removeUnlockMasterVolume(){
        let lm = this;
        // lm.destroyUnlockMasterVolumeBtn();
        if(lm.masterVolumeDisabled){
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',null);
        }
    }

    destroyUnlockMasterVolumeBtn(){
        let lm = this;
        if(lm.masterVolumeUnlockContainer){
            lm.masterVolumeUnlockContainer.remove();
            lm.masterVolumeUnlockContainer = null;
            lm.masterVolumeButton.removeClass('masterVolumeLockAdded');
        }
    }

    disableMasterVolume(silent = false){
        let lm = this;
        lm.renderUnlockMasterVolumeBtn(true);
        lm.sendDisableMasterVolume(silent);
        // lm.masterVolumeContainer.addClass('pe-none')
        lm.masterVolumeDisabled = true;
        kinoControls.toggleSwitch('lock-chatter',true);
        permissions.isWorkspace && permissions.setSetting('lock_chatter',true)
        permissions.isWorkspace && permissions.setSetting('mute_chatter',true)
        lm.masterVolumeUnlockBtn.html(lm.lockIcon).addClass('success');
        !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',true);
        if(!silent){
            Video.showNotification('','You locked background chatter', 'masterVolumeLock','You');
        }
        // lm.updateIndividualVolumeSlider();
        volumeManager.addDisabledMasterVolume();
        lm.updateSpaceSliders()
    }

    disableMasterVolumeHandler(data){
        let lm = this;
        lm.renderUnlockMasterVolumeBtn(true);
        // console.log(data);
        let userName = data ? room.getParticipantById(data.from).getDisplayName() : false;
        // lm.masterVolumeContainer.addClass('pe-none')
        lm.masterVolumeDisabled = true;
        kinoControls.toggleSwitch('lock-chatter',true);
        permissions.isWorkspace && permissions.setSetting('lock_chatter',true)
        permissions.isWorkspace && permissions.setSetting('mute_chatter',true)
        if(permissions.hasChatterLock()){
            lm.masterVolumeUnlockBtn.html(lm.lockIcon).addClass('success');
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',true);
        }
        if(data && !data.silent){
            Video.showNotification('',`${userName} locked background chatter`, 'masterVolumeLock',room.myUserId());
        }else if(!data){
            Video.showNotification('',`Background chatter is locked`, 'masterVolumeLock',room.myUserId());
        }
        // lm.updateIndividualVolumeSlider();
        volumeManager.addDisabledMasterVolume();
        lm.updateSpaceSliders()
    }

    updateSpaceSliders(){
        // if(CONV_STORAGE.myConversation){
            spacesView.updateSliderUI();
        // }
        Object.values(CONV_STORAGE.conversations).forEach(space=>{
            try {
                if(space.id != CONV_STORAGE.myConversation){
                    space.updateSliderUI();
                }
            } catch (error) {
                console.error("Error setting space volumes",error)
            }
        })
    }

    enableMasterVolume(silent = false){
        let lm = this;
        lm.sendEnableMasterVolume(silent);
        // lm.masterVolumeContainer.removeClass('pe-none')
        lm.masterVolumeDisabled = false;
        kinoControls.toggleSwitch('lock-chatter',false);
        permissions.isWorkspace && permissions.setSetting('lock_chatter',false)
        if(lm.masterVolumeUnlockBtn){
            lm.masterVolumeUnlockBtn.html(lm.unlockIcon).removeClass('success');
        }
        !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',null);
        if(!silent){
            Video.showNotification('','You unlocked background chatter', 'masterVolumeLock','You');
        }
        // lm.destroyUnlockMasterVolumeBtn();
        // lm.updateIndividualVolumeSlider();
        volumeManager.addEnabledMasterVolume();
        lm.updateSpaceSliders()
    }

    enableMasterVolumeHandler(data){
        let lm = this;
        let userName = data ? room.getParticipantById(data.from).getDisplayName() : false;
        // if(lm.masterVolumeContainer.hasClass('pe-none')){
        //     lm.masterVolumeContainer.removeClass('pe-none')
        // }
        if(data && !data.silent){
            Video.showNotification('',`${userName} unlocked background chatter`, 'masterVolumeLock',room.myUserId());
        }else if(!data && lm.masterVolumeDisabled){
            Video.showNotification('',`Background chatter is unlocked`, 'masterVolumeLock',room.myUserId());
        }
        lm.masterVolumeDisabled = false;
        kinoControls.toggleSwitch('lock-chatter',false);
        permissions.isWorkspace && permissions.setSetting('lock_chatter',false)
        if(permissions.hasChatterLock()){
            lm.masterVolumeUnlockBtn.html(lm.unlockIcon).removeClass('success');
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_master_volume',null);
        }
        // lm.destroyUnlockMasterVolumeBtn();
        // lm.updateIndividualVolumeSlider();
        volumeManager.addEnabledMasterVolume();
        lm.updateSpaceSliders()
    }
    sendEnableMasterVolume(silent){
        socket.sendUnlockChatter(silent)
    }
    sendDisableMasterVolume(silent){
        socket.sendLockChatter(silent)
    }

    onUserJoin(){
        try {
            if(room && !permissions.isWorkspace){
                let participants=room.getParticipants();
                if(participants){
                    let can_unlock=participants.filter(p=>p.getProperty('can_unlock_master_volume') && Video.videos[p.getId()]);
                    // console.log("Participants that can unlock master volume",can_unlock);
                    if(can_unlock.length > 0){
                        console.warn("Locking masterVolume");
                        volumeManager.muteVolumeOverwrite=true;
                        volumeManager.changeMasterVolume(0);
                        this.disableMasterVolumeHandler(null);
                        Video.showNotification('',`Background chatter is locked`,'masterVolumeLock', room.myUserId());
                    }
                }
            }
        } catch (error) { console.error("[Kino Error] [LockMasterVolume]", error); }
    }

    participantLeft(id){
        try {
            if(room && !permissions.isWorkspace){
                let participants=room.getParticipants();
                if(participants){
                    let can_unlock=participants.filter(p=>p.getProperty('can_unlock_master_volume') && p.getId() != id && Video.videos[p.getId()]);
                    if(can_unlock.length==0 && !CONV_STORAGE.isModerator()){
                        console.warn("Unlocking master volume because no one left to unlock");
                        this.enableMasterVolumeHandler(null);
                    }
                }
            }
        } catch (error) { console.error("[Kino Error] [LockMasterVolume]", error); }
    }

    // updateIndividualVolumeSlider(){
    //     let lm = this;

    //     if(Video.lockMasterVolume.masterVolumeDisabled){
    //         Object.keys(Video.videos).map(id => {
    //             console.log("Should lock volume for partisipant ",(!kinoParticipants.inSameSpaceWith(id) && permissions.shouldLockChatter()))
    //             if(!kinoParticipants.inSameSpaceWith(id) && permissions.shouldLockChatter()){
    //                 Video.addDisabledVolumeControl(id);
    //             }else{
    //                 Video.addEnabledVolumeControl(id);
    //             }
    //         })
    //     }else{
    //         Object.keys(Video.videos).map(id => {
    //             Video.addEnabledVolumeControl(id);
    //         })
    //     }
    // }
}
